import { Controller } from "@hotwired/stimulus"

// Small navigation helpers that replace inline onclick handlers (CSP blocks
// inline JS): row-click navigation and a "go back" button.
export default class extends Controller {
  static values = { url: String }

  visit(event) {
    // Ignore clicks that land on an inner link or button — they have their own
    // destination and shouldn't trigger the row navigation.
    if (event?.target?.closest("a, button")) return

    window.location.href = this.urlValue
  }

  back() {
    window.history.back()
  }
}
